var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Color from 'color';

import ChartLine from './ChartLine';
import ChartLineCompare from './ChartLineCompare';
import ChartLineStacked from './ChartLineStacked';

import ChartArea from './ChartArea';
import ChartAreaStacked from './ChartAreaStacked';

import ChartBar from './ChartBar';
import ChartBarCompare from './ChartBarCompare';
import ChartBarGrouped from './ChartBarGrouped';
import ChartBarStacked from './ChartBarStacked';

import ChartPie from "./ChartPie";

import ChartChoropleth from "./ChartChoropleth";
import ChartSwarmPlot from "./ChartSwarmPlot";

import { getChart, getChartColors } from "../../resources/functions/";

import "./Chart.scss";
import "./Chart--byWeek.scss";
import "./Chart--byDate.scss";
import "./Chart--byHour.scss";

var templates = {
    "line": ChartLine,
    'line-compare': ChartLineCompare,
    "line-stacked": ChartLineStacked,
    "area": ChartArea,
    "area-stacked": ChartAreaStacked,
    "bar": ChartBar,
    "bar-compare": ChartBarCompare,
    "bar-grouped": ChartBarGrouped,
    "bar-stacked": ChartBarStacked,
    "pie": ChartPie,
    "choropleth": ChartChoropleth,
    "swarm-plot": ChartSwarmPlot
};

var Chart = (_temp2 = _class = function (_Component) {
    _inherits(Chart, _Component);

    function Chart() {
        var _temp, _this, _ret;

        _classCallCheck(this, Chart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getProps = function () {
            var _this$props = _this.props,
                type = _this$props.type,
                data = _this$props.data,
                keys = _this$props.keys,
                compare = _this$props.compare,
                stacked = _this$props.stacked;


            if (type === "line" && compare && data && data.length !== 2) {
                compare = false;
            }

            if (type === "bar" && compare && keys && keys.length !== 2) {
                compare = false;
            }

            if (type === "pie") {
                compare = false;
                stacked = false;
            }

            if (stacked && data && data.length < 2) {
                stacked = false;
            }

            return _extends({}, _this.props, {
                compare: compare,
                stacked: stacked
            });
        }, _this.getChart = function () {
            var props = _this.getProps();
            var type = props.type,
                data = props.data,
                colors = props.colors,
                theme = props.theme;


            if (!data) {
                return getChart(props);
            }

            colors = getChartColors(props);

            return _extends({}, props, {
                colors: colors
            });
        }, _this.getClassName = function () {
            var _this$getProps = _this.getProps(),
                type = _this$getProps.type,
                data = _this$getProps.data,
                compare = _this$getProps.compare,
                stacked = _this$getProps.stacked,
                dimension = _this$getProps.dimension,
                days = _this$getProps.days;

            var classNames = [];

            classNames.push("admin-chart");

            if (type) {
                classNames.push("admin-chart--" + type);
            }

            if (type && compare) {
                classNames.push("admin-chart--" + type + "-compare");
            }

            if (type && stacked) {
                classNames.push("admin-chart--" + type + "-stacked");
            }

            // dimension, days, weeks

            if (dimension && dimension.startsWith('ga:nth')) {
                classNames.push("admin-chart--" + dimension.replace('ga:', ''));
            }

            if (days) {
                classNames.push("admin-chart--" + days + "-days");
            }

            if (days && days > 7) {
                var weeks = Math.floor(days / 7);
                classNames.push("admin-chart--" + weeks + "-weeks");
            }

            return classNames.join(' ');
        }, _this.getTemplate = function () {
            var _this$getProps2 = _this.getProps(),
                type = _this$getProps2.type,
                data = _this$getProps2.data,
                compare = _this$getProps2.compare,
                stacked = _this$getProps2.stacked;

            var template = void 0;

            if (type && compare) {
                template = type + "-compare";
            } else if (type && stacked) {
                template = type + "-stacked";
            } else {
                template = type;
            }

            return template;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
    
    getChartColors = () => {
        const { colors, theme } = this.props;
        
        if (colors) {
            return colors
        }
        
        if (!theme) {
            return undefined
        }
        
        let { primaryColor, lightColor, darkColor } = theme;
        
        if (!primaryColor) {
            return undefined
        }
        
        if (!lightColor) {
            lightColor = Color(primaryColor).lighten(0.25)
        }
    
        if (!darkColor) {
            darkColor = Color(primaryColor).darken(0.25)
        }
        
        const c1 = Color(darkColor)
        const c2 = Color(lightColor)
    
        let steps = 5;
        let themeColors = []
    
        for (let i = 0; i < steps; i++) {
            const mix = i/steps
            
            const color = c1.mix(c2, mix)
            themeColors.push(color)
        }
        
        return themeColors
        
    }
    
    */

    Chart.prototype.render = function render() {
        var className = this.getClassName();
        var template = this.getTemplate();

        var error = this.props.error;


        if (error) {
            return React.createElement(
                'div',
                { className: className },
                React.createElement(
                    'p',
                    { className: 'admin-chart__error' },
                    error
                )
            );
        }

        var chart = this.getChart();

        if (templates[template] && chart && chart.data) {
            var ChartTemplate = templates[template];

            return React.createElement(
                'div',
                { className: className },
                React.createElement(ChartTemplate, chart)
            );
        }
    };

    return Chart;
}(Component), _class.defaultProps = {
    theme: {
        primaryColor: "#3154ea",
        lightColor: "#8aa7f7",
        darkColor: "#24439f",
        neutralColor: "#f2f2f2"
    },
    type: "line",
    compare: false,
    stacked: false,
    metric: undefined,
    data: undefined,
    days: undefined,
    tooltipTitle: undefined,
    tooltipLabel: undefined
}, _temp2);


export default Chart;